import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, vModelText as _vModelText, withDirectives as _withDirectives, resolveComponent as _resolveComponent, vShow as _vShow, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "md:items-center justify-between bg-white border-b border-gray-200 flex py-4 px-8 gap-4" }
const _hoisted_2 = { class: "max-w-lg w-full md:w-56 lg:max-w-xs" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("label", {
  for: "search",
  class: "sr-only"
}, "Search", -1)
const _hoisted_4 = { class: "relative text-gray-400 focus-within:text-gray-600" }
const _hoisted_5 = { class: "pointer-events-none absolute inset-y-0 pl-3 left-0 flex items-center" }
const _hoisted_6 = ["placeholder"]
const _hoisted_7 = { class: "px-8 py-6" }
const _hoisted_8 = { class: "space-y-8 divide-y divide-gray-200 bg-white px-10 py-9 rounded-md shadow-md text-center" }
const _hoisted_9 = { class: "py-6" }
const _hoisted_10 = { class: "sm:mx-6 md:mx-8 bg-white shadow overflow-x-auto sm:rounded-md" }
const _hoisted_11 = { class: "shadow overflow-x-auto border-b border-gray-200 sm:rounded-lg" }

import "dayjs/locale/th";
import dayjs from "dayjs";
import stringify from "qs-stringify";
import localizedFormat from "dayjs/plugin/localizedFormat";
import { AxiosInstance } from "axios";
import { useStore } from "vuex";
import { useRoute } from "vue-router";
import { inject, onMounted, ref, watch, computed } from "vue";
import Navbar from "@/components/tools/Navbar.vue";
import DataTable from "@/components/tools/DataTable.vue";
import Pagination from "@/components/tools/Pagination.vue";
import { translate } from "@/utils/tools";
import Toast from "@/components/tools/Toast.vue";
import ViewCouponDialog from "@/components/dialogs/coupon/ViewCouponDialog.vue";
import {
  CouponConditionModeEnum,
  CouponConditionType,
} from "@/views/coupon/type/coupon-condition.type";
import { Coupon } from "@/views/coupon/type/coupon.type";


export default /*#__PURE__*/_defineComponent({
  __name: 'Coupon',
  setup(__props) {

dayjs.extend(localizedFormat);
const SearchIcon = require("@heroicons/vue/solid/SearchIcon");
const axios = inject("$axios") as AxiosInstance;
const store = useStore();
const route = useRoute();
const dataRows = ref<Coupon[]>([]);
const isLoaded = ref(false);
const toastConfig = ref({
  show: false,
  message: "",
  success: false,
  warning:false
});

// View Coupon Dialog
const viewCouponDialog = ref({
  show: false,
  coupon: null as Coupon | null
});

const baseColumns = [
  {
    label: translate("messages.coupon.code"),
    field: "code",
    align: "center",
    format: (data: Coupon) => data.code ? data.code : '-',
  },
  {
    label: translate("messages.coupon.used"),
    field: "used",
    align: "center",
    format: (data: Coupon) => (data.isUsed ? " ╳ " : ` ✓ `),
    class: (data: Coupon) => (data.isUsed ?  'content-center bg-red-500 hover:bg-red-700 text-white font-bold rounded-full': 'content-center bg-blue-500 hover:bg-blue-700 text-white font-bold rounded-full')
  },
  {
    label: translate("messages.coupon.createdAt"),
    field: "createdAt",
    align: "center",
    format: (data: Coupon) => dayjs(data.createdAt).locale("th").format("LLL"),
  },
  {
    label: translate("messages.coupon.expiredAt"),
    field: "expiredAt",
    align: "center",
    format: (data: Coupon) => data.expiredAt ? dayjs(data.expiredAt).locale("th").format("LLL") : '-',
  },
];

const userIdColumn = {
  label: translate("messages.coupon.userId"),
  field: "userId",
  align: "center",
  format: (data: Coupon) => data.userId ? data.userId : "-",
};

const viewCouponColumn = {
  label: translate("messages.coupon.viewCoupon"),
  field: "View Coupon Usage",
  align: "center",
  isFunction: true,
  function: async (data: Coupon) => {
    await viewCouponUsage(data);
  },
  class: (data: Coupon) => {
    return 'content-center bg-blue-500 hover:bg-blue-700 text-white font-bold rounded-full'
  },
  format: (data: Coupon) => {
    return translate("messages.coupon.viewCoupon")
  },
};

// คำนวณคอลัมน์ที่จะแสดงตามเงื่อนไข
const filteredColumns = computed(() => {
  const columns = [...baseColumns];
  
  if (pageConfig.value.generic === true) {
    // แสดง viewCoupon
    columns.splice(2, 0, viewCouponColumn);
  } else {
    // แสดง userId
    columns.splice(2, 0, userIdColumn);
  }
  
  return columns;
});

const pageConfig = ref({
  search: ``,
  page: 1,
  count: 0,
  pageCount: 0,
  rowsPerPage: 10,
  dataLength: 0,
  couponConditionId: undefined,
  generic: null,
  sort: [["id", "DESC"]],
});

// Function to view coupon usage
const viewCouponUsage = async (coupon: Coupon) => {
  try {
    console.log(coupon)
    // ถ้า coupon มี couponUsages แล้ว ให้แสดง dialog เลย
    if (coupon.couponUsages && coupon.couponUsages.length >= 0) {
      viewCouponDialog.value.coupon = coupon;
      viewCouponDialog.value.show = true;
      return;
    }

    // หากไม่มี ให้ fetch ข้อมูลก่อน
    const url = `${process.env.VUE_APP_API_ENDPOINT}/admin/api/v1/loyalty/api/internal/coupon/${coupon.id}/usage`;
    const response = await axios.get(url);
    
    // Update coupon with usage data
    const updatedCoupon = {
      ...coupon,
      couponUsages: response.data
    };
    
    viewCouponDialog.value.coupon = updatedCoupon;
    viewCouponDialog.value.show = true;
    
  } catch (error) {
    console.error('Error fetching coupon usage:', error);
    toastConfig.value = {
      show: true,
      message: 'เกิดข้อผิดพลาดในการดึงข้อมูลการใช้งานคูปอง',
      success: false,
      warning: false
    };
  }
};

const fetchPageData = async () => {
  isLoaded.value = false

  const { page, rowsPerPage, search, couponConditionId, generic } = pageConfig.value;

  const payload: any = {
    couponConditionId,
    page: page,
    pageSize: rowsPerPage,
    code: search ? search : undefined,
  };

  const url = `${process.env.VUE_APP_API_ENDPOINT}/admin/api/v1/loyalty/api/internal/coupon/pagination`;
  const data = await axios
      .post<Coupon[]>(url, payload)
      .then(({ data }) => data);

  pageConfig.value.dataLength = data.length;

  if (data.length > 0) dataRows.value = data
  else dataRows.value = [];
  pageConfig.value = {
    ...pageConfig.value,
  };
  /** update url to persist page config */
  window.history.replaceState(
      {},
      document.title,
      `?${stringify({ couponConditionId, page, rowsPerPage, generic })}`
  );
  isLoaded.value = true;
};

onMounted(() => {
  pageConfig.value.page = Number(route.query.page) || 1;
  pageConfig.value.rowsPerPage = Number(route.query.rowsPerPage) || 10;
  pageConfig.value.couponConditionId = Number(route.query.couponConditionId)
  pageConfig.value.generic = JSON.parse(route.query.generic)
  fetchPageData();
});

/** fetch data when current page was changed */
watch(
    () => pageConfig.value.page,
    () => fetchPageData()
);

watch(
    () => pageConfig.value.couponConditionId,
    () => fetchPageData()
);
/** fetch data when rows per page was changed */
watch(
    () => pageConfig.value.rowsPerPage,
    () => {
      pageConfig.value.page = 1;
      fetchPageData();
    }
);

return (_ctx: any,_cache: any) => {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(Navbar, {
      title: _ctx.$t('messages.coupon.coupon')
    }, null, 8, ["title"]),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_unref(SearchIcon), {
              class: "h-5 w-5",
              "aria-hidden": "true"
            })
          ]),
          _withDirectives(_createElementVNode("input", {
            id: "search",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((pageConfig.value.search) = $event)),
            class: "block w-full bg-white py-2 pl-10 focus:bg-white pr-3 border border-transparent rounded-md leading-5 text-gray-900 placeholder-gray-500 focus:ring-offset-blue-600 focus:ring-white focus:border-white sm:text-sm",
            placeholder: _ctx.$t('messages.coupon.search'),
            onInput: _cache[1] || (_cache[1] = ($event: any) => (fetchPageData(true))),
            type: "search",
            name: "search"
          }, null, 40, _hoisted_6), [
            [_vModelText, pageConfig.value.search]
          ])
        ])
      ])
    ]),
    _withDirectives(_createElementVNode("div", _hoisted_7, [
      _createElementVNode("div", _hoisted_8, [
        _createVNode(_component_font_awesome_icon, {
          class: "text-gray-500",
          icon: ['fas', 'circle-notch'],
          transform: "grow-6",
          spin: ""
        })
      ])
    ], 512), [
      [_vShow, !isLoaded.value]
    ]),
    _withDirectives(_createElementVNode("div", _hoisted_9, [
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("div", _hoisted_11, [
          _createVNode(DataTable, {
            columns: _unref(filteredColumns),
            data: dataRows.value
          }, null, 8, ["columns", "data"]),
          _createVNode(Pagination, {
            config: pageConfig.value,
            "onUpdate:config": _cache[2] || (_cache[2] = ($event: any) => ((pageConfig).value = $event))
          }, null, 8, ["config"])
        ])
      ])
    ], 512), [
      [_vShow, isLoaded.value]
    ]),
    _createVNode(ViewCouponDialog, {
      show: viewCouponDialog.value.show,
      "onUpdate:show": _cache[3] || (_cache[3] = ($event: any) => ((viewCouponDialog.value.show) = $event)),
      coupon: viewCouponDialog.value.coupon
    }, null, 8, ["show", "coupon"]),
    _createVNode(Toast, {
      show: toastConfig.value.show,
      "onUpdate:show": _cache[4] || (_cache[4] = ($event: any) => ((toastConfig.value.show) = $event)),
      message: toastConfig.value.message,
      success: toastConfig.value.success
    }, null, 8, ["show", "message", "success"])
  ], 64))
}
}

})